import { Box } from "@mui/system";
import React, { useEffect, useState } from "react";
import VerticalTab from "../Tab/VerticalTab";
import {
  Step,
  StepConnector,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import { fixTextBeforeDisplay } from "../../Utils/helper";
import styles from "./CommentsBox.module.css";

const CommentsBox = ({ data = [], sidebarTable = false }) => {
  const { lobName } = useSelector((state) => state?.CaseDescriptionSlice);
  const [tabValue, setTabValue] = useState("");
  const [renderData, setRenderData] = useState(null);

  const CustomStepIcon = () => <Box className={styles.customStepIcon} />;

  const CustomConnector = (props) => (
    <StepConnector {...props} className={styles.customConnector} />
  );

  const handleChange = (e) => {
    setTabValue(e.target.innerText);
  };

  const tabs =
    data?.map((item) => ({
      label: item?.role_label,
    })) || [];

  useEffect(() => {
    setTabValue(tabs[0]?.label);
  }, [data]);

  useEffect(() => {
    if (tabValue) {
      setRenderData(data?.find((item) => item?.role_label === tabValue));
    }
  }, [tabValue, data]);

  return (
    <Box className={styles.commentsContainer}>
      <Box className={styles.leftPanel}>
        {sidebarTable && data?.length > 0 && (
          <VerticalTab
            tab={
              lobName === "Motor"
                ? tabs.filter(
                    (role) => role.label !== "BS" && role.label !== "BSTL"
                  )
                : tabs
            }
            handleChange={handleChange}
          />
        )}
      </Box>

      {data?.length > 0 && renderData ? (
        <Box className={styles.stepperWrapper}>
          <Box className={styles.scrollContainer}>
            <Typography className={styles.stepperHeader}>
              {renderData?.employee_name}
            </Typography>

            <Stepper
              orientation="vertical"
              activeStep={-1}
              connector={<CustomConnector />}
              className={styles.stepperMain}
            >
              {renderData?.description_details?.map((item, index) => (
                <Step key={index} expanded>
                  <StepLabel
                    StepIconComponent={CustomStepIcon}
                    className={styles.stepLabel}
                  >
                    {item.described_at?.replace(" ", " | ")}
                  </StepLabel>

                  <StepContent>
                    <Typography className={styles.stepContentText}>
                      {fixTextBeforeDisplay(item.description)}
                    </Typography>
                  </StepContent>
                </Step>
              ))}
            </Stepper>
          </Box>
        </Box>
      ) : (
        <Box className={styles.noDataBox}>No Data</Box>
      )}
    </Box>
  );
};

export default CommentsBox;